/**
 * Created by guga on 7/29/2016.
 */

import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable }     from 'rxjs/Observable';
import { Subscription }   from 'rxjs/Subscription';

import 'rxjs/add/operator/multicast';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observer }        from 'rxjs/Observer';

import { BaseSas }                from './base.sas';
import { ErrorHandlerBuilderSas } from './error-handler-builder.sas';
import { ConfigSas }              from './config.sas';


import { ErrorHandlerSas }        from './error-handler.sas';
import { IRequestErrorHandler }   from '../sas-models/error-handler';
import { UserBean }              from '../beansts/index';
import { AuthState, AuthStatus, Token, IRequestPayload, RequestMethod } from '../sas-models/index';

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 29/07/2016
 *
 * This service is responsible for authentication. It provides a token and loginStatus stream which you can subscribe to get updates
 *
 *
 * Examples of use :
 *
 *   ## LOGIN
 *   this._auth.login('username', 'password').subscribe(
 *     (authState    : AuthState) => console.log('Logged!'),
 *     (errorMessage : string)    => console.error('Could not log :' + errorMessage);
 *   );
 *
 *   ## LOGOUT
 *   this._auth.logout();
 *
 *   ## SUBSCRIBING TO AUTH STATE STREAM
 *   this._auth.authState$.subscribe(
 *     (authState : AuthState) => console.log(authState)
 *   );
 *
 *   ## GET CURRENT AUTH STATE VALUE WITHOUT SUBSCRIBING
 *   console.log(this._auth.authState);
 *
 ***********************************************/

@Injectable()
export class AuthSas extends BaseSas {
    public _authState$ : BehaviorSubject<AuthState>;

    public constructor(private _http : Http,private _config : ConfigSas, private _ehb : ErrorHandlerBuilderSas, errorHandler : ErrorHandlerSas) {
        super(errorHandler);
        this._createInitialAuthState();
    }

    private _createInitialAuthState() : void {
        this._authState$ = new BehaviorSubject<AuthState>(new AuthState(null, AuthStatus.Unauthenticated));
    }

    private _getToken(username : string, password : string, authenticationErrorHandler ?: IRequestErrorHandler) : Observable<Token> {
        let keyId    : string = username + password;
        let loginUrl : string = `${this._config.apiHost}/oauth/token?grant_type=password&client_id=minhasaude&username=email_${keyId}&password=`;
        let requestPayload : IRequestPayload = {
            url     : loginUrl,
            options : null,
            method  : RequestMethod.get
        };
        let errorHandler : IRequestErrorHandler = authenticationErrorHandler || this.authenticationErrorHandler;

        return this._http.get(loginUrl)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
    }

    public create(user : UserBean, authenticationErrorHandler ?: IRequestErrorHandler) : Observable<number> {
        let loginUrl : string = `${this._config.apiHost}/users`;
        let requestPayload : IRequestPayload = {
            url     : loginUrl,
            options : null,
            method  : RequestMethod.post
        };
        let errorHandler : IRequestErrorHandler = authenticationErrorHandler || this.authenticationErrorHandler;

        return this._http.post(loginUrl,user,null)
            .map( (res : Response) => res.json() )
            .catch( this._ehb.buildRequestErrorHandler(errorHandler, requestPayload) );
    }

    public get authState$() : Observable<AuthState> {
        return this._authState$.asObservable();
    }

    public get authState() : AuthState {
        return this._authState$.getValue();
    }

    public setAuthState(authState : AuthState) : void {
        this._authState$.next(authState);
    }

    public login(username : string, password : string, authenticationErrorHandler ?: IRequestErrorHandler) : Observable<AuthState> {
        return Observable.create(
            (observer : Observer<AuthState>) => {
                let getTokenSubscription : Subscription = this._getToken(username, password, authenticationErrorHandler).subscribe(
                    (token : Token) => {
                        let authState : AuthState = new AuthState(token, AuthStatus.Authenticated);
                        this.setAuthState(authState);
                        observer.next(authState);
                        observer.complete();
                    },
                    (err : any) => {
                        observer.error(err);
                    }
                );

                return () => {
                    if (getTokenSubscription)
                        getTokenSubscription.unsubscribe();
                }
            }
        );
    }

    public logout() : void {
        this.setAuthState(new AuthState(null, AuthStatus.Unauthenticated));
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/auth.sas.ts